"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ChainLink {
    constructor(chainElement, prev) {
        this.chainElement = chainElement;
        this.prev = prev;
        // Intentionally left empty
    }
    send(request) {
        this.chainElement.send(request, this.next, this.prev);
    }
    responseReceived(request) {
        this.chainElement.responseReceived(request, this.next, this.prev);
    }
}
class ChainStartLink {
    constructor(finalResponseReceived) {
        this.finalResponseReceived = finalResponseReceived;
    }
    responseReceived(req) {
        this.finalResponseReceived(req);
    }
}
class Chain {
    constructor(chainElements, finalResponseReceived) {
        this.links = [];
        let prev = undefined;
        for (let i = 0; i < chainElements.length; i++) {
            let link;
            if (prev) {
                link = new ChainLink(chainElements[i], prev);
                // Set next on previous chain link
                prev.next = link;
            }
            else {
                link = new ChainLink(chainElements[i], new ChainStartLink(finalResponseReceived));
            }
            this.links.push(link);
            prev = link;
        }
    }
    send(request) {
        this.links[0].send(request);
    }
}
exports.default = Chain;
//# sourceMappingURL=Chain.js.map